import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';

export const postgreSqlTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.postgreSql.datasetType,
    disabled: __IS_FABRIC_DPE__,
    displayName: getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true),
    warningMessage: format(
        stringResources.Connector_Legacy_IsNotSupportedWarning_alt2,
        stringResources.DatasetLowerCase,
        stringResources.PostgreSql_DisplayText
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-postgresql?tabs=data-factory', // Need to update
    supportLinkedServiceTypes: [adfModelTypeMap.postgreSql.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-PostgreSQL'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    splitTablePath: true,
    category: ['Database']
};
